var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{active: _vm.isActive},attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }